import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { WithErrorLabel } from '@hobs/components/FormError';
import InputLabel from '../InputLabel';

import Styles from './Input.module.scss';

const Input = ({
  large = false,
  field,
  placeholder,
  children,
  disabled,
  error,
  type = 'text',
  onChange = () => {},
  icon,
  search,
  onKeyUp,
  onBlur = () => {},
  onKeyPress = () => {},
  onPaste = () => {},
  noMargin,
  value,
  maxLength,
  innerRef,
  autoComplete,
  className,
  name,
  borderless = false,
  indicationMessage,
  defaultValue
}) => {
  return (
    <div
      className={classNames(
        Styles['form-item'],
        {
          [Styles.large]: large,
          [Styles['with-icon']]: icon,
          [Styles.search]: search,
          [Styles['search-tiny']]: search === 'tiny',
          [Styles['no-margin']]: noMargin,
          [Styles['form-error-input']]: error,
          [Styles['form-item-borderless']]: borderless,
          [className]: className
        },
        'stop-drag'
      )}
    >
      {children && (
        <InputLabel indicationMessage={indicationMessage}>
          {children}
        </InputLabel>
      )}
      {icon ? icon : null}
      <input
        disabled={disabled}
        type={type}
        placeholder={placeholder}
        onKeyUp={onKeyUp}
        value={value}
        ref={innerRef}
        autoComplete={autoComplete}
        maxLength={maxLength}
        name={name}
        {...field}
        onChange={event => {
          onChange(event);
          if (field && field.onChange) {
            field.onChange(event);
          }
        }}
        onKeyPress={onKeyPress}
        onPaste={onPaste}
        onBlur={event => {
          onBlur(event);
          if (field && field.onBlur) {
            field.onBlur(event);
          }
        }}
        defaultValue={defaultValue}
      />
      {error && <label className={Styles['form-error']}>{error}</label>}
    </div>
  );
};

Input.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number
  ]),
  name: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.object
  ]),
  className: PropTypes.string,
  innerRef: PropTypes.any,
  large: PropTypes.bool,
  disabled: PropTypes.bool,
  noMargin: PropTypes.bool,
  search: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  form: PropTypes.object,
  field: PropTypes.object,
  placeholder: PropTypes.string,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onPaste: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  icon: PropTypes.element,
  type: PropTypes.oneOf(['time', 'text', 'password', 'date', 'number']),
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  autoComplete: PropTypes.string,
  borderless: PropTypes.bool,
  indicationMessage: PropTypes.object,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number
  ])
};

export default WithErrorLabel(Input);
